/**
 * Q&A API service
 */

import apiClient from './api';

export interface QASubmission {
  agent_id: string;
  answer: string;
}

export interface CurrentQuestion {
  question: string;
  agent_id: string;
  agent_name: string;
  question_number: number;
  total_questions: number;
  agent_number: number;
  total_agents: number;
  all_complete?: boolean;
}

export interface QAResponse {
  next_question?: string;
  agent_id?: string;
  agent_name?: string;
  question_number?: number;
  total_questions?: number;
  agent_number?: number;
  total_agents?: number;
  agent_complete?: boolean;
  all_agents_complete?: boolean;
  message?: string;
  next_agent_id?: string;
  next_agent_name?: string;
}

export const qaService = {
  /**
   * Get the current question for a session
   */
  async getCurrentQuestion(sessionId: string): Promise<CurrentQuestion> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/qa/current`);
    return response.data;
  },

  /**
   * Submit an answer to the current question
   */
  async submitAnswer(sessionId: string, submission: QASubmission): Promise<QAResponse> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/qa`, submission);
    return response.data;
  },

  /**
   * Get Q&A history for a session
   */
  async getHistory(sessionId: string): Promise<any> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/qa/history`);
    return response.data;
  },
};

export default qaService;
